import { API_REQUEST_TYPES } from "../../enums";
import { resetApi } from "../../services/axios";
import { API } from "../endpoints";
import { getUpdatedProjectInvitationList } from "./utils";

export function createProject(payload) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.POST,
        url: API.PROJECT.CREATE_PROJECT,
        payload,
        config: {
          notifyError: true,
        },
      })
    );

    if (res.success) {
    }

    return res;
  };
}

export function submitVendorAvailibility(payload, id) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.PUT,
        url: API.PROJECT.SUBMIT_VENDOR_AVAILIBILITY(id),
        payload,
        config: {
          notifyError: false,
        },
      })
    );

    if (res.success) {
    }

    return res;
  };
}

export function submitBatchAmbassadorRequest() {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.POST,
        url: API.PROJECT.SUBMIT_BATCH_AMBASSADOR_REQUEST,
        payload: {},
        config: {
          notifyError: true,
          notifySuccess: true,
        },
      })
    );

    if (res.success) {
    }

    return res;
  };
}

export function getRecording(token) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.GET,
        url: API.PROJECT.GET_RECORDING(token),
        config: {
          notifyError: false,
        },
      })
    );

    if (res.success) {
    }

    return res;
  };
}

export function getBlockedDates({ from, to }) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.GET,
        url: API.PROJECT.GET_BLOCKED_DATES({ from, to }),
        payload: {},
        config: {
          notifyError: false,
        },
      })
    );

    return res;
  };
}

export function getUpcomingMeetings(payload: { timezone?: string } = {}) {
  return async function (dispatch: any) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.GET,
        url: API.PROJECT.GET_UPCOMING_MEETINGS(payload?.timezone ?? ""),
        payload: {},
        config: {
          notifyError: false,
        },
      })
    );

    if (res?.success === false) {
      throw new Error(res?.message || "Failed to load upcoming meetings");
    }

    return {
      success: true,
      data: res?.data ?? [],
      total: res?.total ?? 0,
    };
  };
}

export function getProjects(params: {
  selectedDate?: string;
  selectedStatus?: string;
} = {}) {
  return async function (dispatch: any) {
    const { selectedDate = "", selectedStatus = "" } = params;
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.GET,
        url: API.PROJECT.GET_PROJECTS({ selectedDate, selectedStatus }),
        payload: {},
        config: { notifyError: true },
      })
    );

    if (res?.success === false) {
      throw new Error(res?.message || "Failed to load initiatives");
    }

    const data = (res?.data ?? []).map((d: any) => ({
      ...d,
      invitations: getUpdatedProjectInvitationList(d?.invitations),
    }));

    return { success: true, data, total: res?.total ?? 0 };
  };
}

export function getVendorAmbassadorList() {
  return async function (dispatch: any) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.GET,
        url: API.PROJECT.GET_AMBASSADOR_LIST_FOR_PROJECT,
        payload: {},
        config: { notifyError: true },
      })
    );

    if (res?.success === false) {
      throw new Error(res?.message || "Failed to load ambassadors");
    }

    return {
      success: true,
      data: res?.data ?? [],
      total: res?.total ?? 0,
    };
  };
}